// extracted by mini-css-extract-plugin
module.exports = {"root":"register_root__3o9nY","main":"register_main__3LflP","title":"register_title__2cO1Y","subtitle":"register_subtitle__3nOo3","submit":"register_submit__2Y4vm"};